import React from 'react';
import { CalendarPlus, Download } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { trackHomeEvent } from './ShareCountdownButton';

const EVENT_TITLE = 'Tecniche Perfette — Finale Nazionale';
const EVENT_DESC = 'Finale nazionale del torneo di freestyle Tecniche Perfette. Info su www.tecnicheperfette.com';

const compact = (d) => d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

const buildDates = (date) => {
  const start = new Date(`${date}T20:00:00+02:00`);
  const end = new Date(start.getTime() + 4 * 3600000);
  return { start, end };
};

const googleUrl = (date) => {
  const { start, end } = buildDates(date);
  const p = new URLSearchParams({
    action: 'TEMPLATE',
    text: EVENT_TITLE,
    details: EVENT_DESC,
    dates: `${compact(start)}/${compact(end)}`,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

const downloadIcs = (date) => {
  const { start, end } = buildDates(date);
  const ics = [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Tecniche Perfette//IT', 'BEGIN:VEVENT',
    `UID:tp-finale-${date}@tecnicheperfette.com`,
    `DTSTAMP:${compact(new Date())}`,
    `DTSTART:${compact(start)}`,
    `DTEND:${compact(end)}`,
    `SUMMARY:${EVENT_TITLE}`,
    `DESCRIPTION:${EVENT_DESC}`,
    'BEGIN:VALARM', 'TRIGGER:-P1D', 'ACTION:DISPLAY', `DESCRIPTION:${EVENT_TITLE} domani!`, 'END:VALARM',
    'END:VEVENT', 'END:VCALENDAR',
  ].join('\r\n');
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `tecniche-perfette-finale-${date}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const RemindMeButton = ({ date }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button
        type="button"
        data-testid="remind-me-btn"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-red-600 to-red-800 hover:from-red-500 hover:to-red-700 text-white font-bold text-sm sm:text-base shadow-xl transition-transform hover:scale-105 border border-red-400/40"
        style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '0.5px' }}
      >
        <CalendarPlus size={18} />
        RICORDAMELO
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="center" className="bg-gray-900 border-gray-700 text-white min-w-[220px]">
      <DropdownMenuItem asChild>
        <a
          href={googleUrl(date)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="remind-google-link"
          onClick={() => trackHomeEvent('remind_google')}
          className="flex items-center gap-2 cursor-pointer focus:bg-gray-800 focus:text-white"
        >
          <CalendarPlus size={15} className="text-red-500" /> Google Calendar
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => { trackHomeEvent('remind_ics'); downloadIcs(date); }}
        data-testid="remind-ics-btn"
        className="flex items-center gap-2 cursor-pointer focus:bg-gray-800 focus:text-white"
      >
        <Download size={15} className="text-red-500" /> Apple / Outlook (.ics)
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default RemindMeButton;
